// extracted by mini-css-extract-plugin
export default {"cardWrapper":"PeroductListPage_cardWrapper__Hu7v6"};